import { createContext } from 'react';

export const ThemePreferencesContext = createContext({
    toggleTheme: () => { },
    isDarkMode: false,
});
